import { render, staticRenderFns } from "./PublicSection.vue?vue&type=template&id=37d811d2&scoped=true"
import script from "./PublicSection.vue?vue&type=script&lang=js"
export * from "./PublicSection.vue?vue&type=script&lang=js"
import style0 from "./PublicSection.vue?vue&type=style&index=0&id=37d811d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d811d2",
  null
  
)

export default component.exports